import { sortBy } from "lodash";
import moment from "moment";
import { ProfileExport } from "PFTypes";

const sortByDate = (
  internalExperiences: ProfileExport["internal_experiences"],
  prop: "start_date" | "end_date"
) =>
  sortBy(internalExperiences, (experience) => {
    const dateRange = experience.metadata.date_range || {};
    if (!dateRange[prop]) {
      return Infinity;
    } else if (dateRange.current) {
      return -Infinity;
    } else {
      return -moment(dateRange[prop]);
    }
  });

export const sortInternalExperiences = (
  internalExperiences: ProfileExport["internal_experiences"]
): ProfileExport["internal_experiences"] => {
  const idSorted = sortBy(internalExperiences, "id").reverse();
  const endDateSorted = sortByDate(idSorted, "end_date");
  return sortByDate(endDateSorted, "start_date");
};
